// extracted by mini-css-extract-plugin
export var divider = "_dn-7";
export var itemsToggle = "_dn-8";
export var mergeModal = "_dn-1";
export var optionCard = "_dn-4";
export var radioGroup = "_dn-6";
export var radioOption = "_dn-0";
export var selected = "_dn-5";
export var shipmentOptions = "_dn-2";
export var tableOptions = "_dn-3";